export const ROUTES = {
  LABEL: `/label/:id`,
  LABELS: '/labels',
  LICENCES: '/licences',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  SETTINGS: '/settings',
  PREMIUM_FEATURES: '/settings/premium-features',
  PRIVACY_POLICY: '/privacy-policy',
  PROFILE_SETTINGS: '/settings/profile',
  SIGNUP: '/signup',
  STUCK: '/stuck',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  VERIFY_EMAIL: '/verify-email',
  COSTUMER_WINEFO_POINT: '/w/:id',
};
